import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  mapToModel,
  toModelArray,
} from '@kinet-open-network/client/shared/data-access/model';
import { IPredefinedText } from '@kinet-open-network/shared/data-access/model';
import { Observable, map } from 'rxjs';
import { PredefinedText } from './predefined-text.model';

@Injectable({
  providedIn: 'root',
})
export class PredefinedTextsService {
  private http = inject(HttpClient);

  getByKey(key: string): Observable<PredefinedText[]> {
    return this.http
      .get<{ data: IPredefinedText[] }>(
        `/predefined-texts/by-key/${encodeURIComponent(key)}`,
      )
      .pipe(map(({ data }) => toModelArray(data, PredefinedText)));
  }

  create(payload: { key: string; text: string }): Observable<PredefinedText> {
    return this.http
      .post<{ data: IPredefinedText }>(`/predefined-texts`, payload)
      .pipe(mapToModel(PredefinedText, 'data'));
  }

  update(id: string, payload: { text: string }): Observable<PredefinedText> {
    return this.http
      .put<{ data: IPredefinedText }>(`/predefined-texts/${id}`, payload)
      .pipe(mapToModel(PredefinedText, 'data'));
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`/predefined-texts/${id}`);
  }
}
